export const SIGNATURE_FONTS = [
  { name: 'Dancing Script', family: "'Dancing Script', cursive" },
  { name: 'Kalam', family: "'Kalam', cursive" },
  { name: 'Caveat', family: "'Caveat', cursive" },
  { name: 'Shadows Into Light', family: "'Shadows Into Light', cursive" },
  { name: 'Satisfy', family: "'Satisfy', cursive" },
] as const

export type SignatureFont = (typeof SIGNATURE_FONTS)[number]

export const DEFAULT_SIGNATURE_FONT = SIGNATURE_FONTS[0]
